import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-customer-onboarding',
  templateUrl: './customer-onboarding.component.html',
  styleUrls: ['./customer-onboarding.component.scss']
})
export class CustomerOnboardingComponent implements OnInit {
  business: string = '';
  email: string = '';
  contact: string = '';
  password: string = '';
  isLoading: boolean = false;
  hasDraft: boolean = false;
  customerId: string = localStorage.getItem('leadId') || '';
  draftStep: number = 0; // Store the draft step for resumption
  isCheckingDraft: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiService
  ) {}

  ngOnInit() {
    console.log('[ngOnInit] Initialization started');
    this.route.queryParams.subscribe((params) => {
      this.business = params['business'] || '';
      this.email = params['email'] || '';
      this.contact = params['contact'] || '';
      this.password = params['password'] || '';

      console.log('[ngOnInit] Query Params:', params);
      console.log(`[ngOnInit] Parsed - Business: ${this.business}, Email: ${this.email}, Contact: ${this.contact}`);

      this.checkForExistingProgress();
    });
  }

  // Check if the user has existing onboarding progress
  checkForExistingProgress() {
    if (!this.email) {
      console.log('[checkForExistingProgress] No email provided, cannot check for progress');
      this.isLoading = false;
      this.isCheckingDraft = false;
      return;
    }

    this.isLoading = true;
    this.isCheckingDraft = true;
    const payload = {
      company_name: this.business,
      email: this.email,
      phone: this.contact,
      password: this.password,
    };

    this.api.startOnboarding(payload).subscribe({
      next: (res: any) => {
        console.log('[checkForExistingProgress] StartOnboarding API response:', res);
        this.customerId = res.Customer_id; // Match the API response key
        localStorage.setItem('leadId', this.customerId);
        console.log(`[checkForExistingProgress] Stored customerId: ${this.customerId}`);

        // Check for existing data mismatch
        if (res.existing && (this.business !== res.company_name || this.contact !== res.phone)) {
          const useExisting = confirm(
            `We have the following data on record:\nBusiness: ${res.company_name}\nContact: ${res.phone}\nDo you want to use this data? Click OK to use existing, Cancel to use new.`
          );
          if (!useExisting) {
            this.api.updateOnboardingData(this.customerId, { company_name: this.business, phone: this.contact }).subscribe({
              next: () => console.log('Updated onboarding data with new values'),
              error: (err) => console.error('Failed to update data:', err)
            });
          } else {
            this.business = res.company_name;
            this.contact = res.phone;
          }
        } else if (res.existing) {
          this.business = res.company_name;
          this.contact = res.phone;
        }

        // Check for draft data directly from startOnboarding response
        if (res.form_step > 0 && res.form_data && res.current_step !== 'completed') {
          this.hasDraft = true;
          this.draftStep = res.form_step; 
          console.log(`[checkForExistingProgress] Draft exists at step ${this.draftStep}`);
        } else {
          this.hasDraft = false;
          console.log('[checkForExistingProgress] No draft found or form already submitted');
        }
        this.isLoading = false;
        this.isCheckingDraft = false;
      },
      error: (err) => {
        console.error('[checkForExistingProgress] Error while checking for existing progress:', err);
        this.isLoading = false;
        this.isCheckingDraft = false;
        alert('Could not start onboarding. Please try again.');
      }
    });
  }

  continueOnboarding() {
    console.log('[continueOnboarding] Called');
    if (this.hasDraft) {
      console.log(`[continueOnboarding] Navigating to onboarding/form with step ${this.draftStep}`);
      this.router.navigate(['/onboarding/form'], { queryParams: { step: this.draftStep } });
    } else {
      console.warn('[continueOnboarding] Cannot continue, no draft exists');
    }
  }

  startOnboarding() {
    console.log('[startOnboarding] Called');
    if (!this.customerId) {
      console.warn('[startOnboarding] No customerId, cannot start onboarding');
      return;
    }
    this.router.navigate(['/onboarding/form'], { queryParams: { step: 1 } });
    console.log('[startOnboarding] Navigated to onboarding/form');
  }


cancel() {
  console.log('[cancel] Called');
  if (this.customerId) {
    this.api.clearFormData(this.customerId).subscribe({
      next: () => {
        console.log('[cancel] Cleared form data');
        localStorage.removeItem('leadId');
        window.location.href = 'https://whatnow.group/sign-up';
      },
      error: (err) => {
        console.error('[cancel] Error while clearing form data:', err);
        alert('Could not clear form data. Please try again.');
      }
    });
  } else {
    console.warn('[cancel] No customerId, cannot clear form data');
    window.location.href = 'https://whatnow.group/sign-up';
  }
}


}